import React from 'react';
import { Tag } from '@econ/ui-elements';
import Text from '../../../shared/components/l10n/Text';
import { withEContext } from '../../../shared/components/EContext';
import CompanyLogo from './CompanyLogo';
import icons from '../../Header/icons';

function Agreement({
    children,
    context,
    name,
    number,
    userId,
    isAdministrator,
    isDeveloper,
    enforce2Fa,
    logo,
    onClick,
    ...props
}) {
    const content = (
        <React.Fragment>
            <span className="agreement_details__agreement__name" title={name}>
                {name} {enforce2Fa ? icons.lock : null}
            </span>
            {number} {userId}
            {isAdministrator ? (
                <Tag type="warning">
                    <Text id="AGREEMENT_SELECTOR_ADMINISTRATOR">Administrator</Text>
                </Tag>
            ) : null}
            {isDeveloper ? (
                <Tag type="primary">
                    <Text id="AGREEMENT_SELECTOR_DEVELOPER">Developer</Text>
                </Tag>
            ) : null}
            {children}
        </React.Fragment>
    );

    if (typeof onClick === 'function') {
        return (
            <button {...props} onClick={onClick} className="agreement_details__agreement" tabIndex={0}>
                <CompanyLogo agreementNumber={number} />
                <div>{content}</div>
            </button>
        );
    }

    return (
        <div {...props} className="agreement_details__agreement">
            {' '}
            {content}
        </div>
    );
}

export default withEContext(Agreement);
